import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { NgSelectConfig } from "@ng-select/ng-select";
import { Observable } from "rxjs";
import { BsModalService } from "ngx-bootstrap/modal";
import { ChangeDetectorRef } from "@angular/core";

@Component({
  selector: "app-edit-sales-target",
  templateUrl: "./edit-sales-target.component.html",
  styleUrls: ["./edit-sales-target.component.css"],
})
export class AddSalesTargetComponent implements OnInit {
  http: any;
  selectedItems = [];
  comps: string[] = [];
  productGroupHd: Observable<string[]>;
  userRId: any;
  @ViewChild("showmti") showmti: any;
  valid: number;
  CategoryShow: any;
  modalRef: any;
  salesEngineer: any;
  rowId: any;
  emailId: any;
  FinancialYear: any;
  prevBill: number = 0;
  prevBook: number = 0;
  groups: any = [];
  rowvalue: any = [];
  registerForm: FormGroup;
  submitted = false;
  multiClick = false;
  id: any;
  isFiltersRendered: boolean = false;
  dollar: boolean = false;
  salesEng: any = [];
  isRender: boolean = true;
  dropdownSetting: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  userId: any;
  inquiryProduct: any = [];
  rowIndex: any = [];
  dropdownSettings: any = {};
  totalProductSize: number;
  errror: any = "";
  permission: any;
  nonEdit: boolean = true;
  quotationArray: any = [];
  financialArray: any = [];
  TotalBilling: number = 0;
  TotalBooking: number = 0;
  checkClass: any = "";
  Modulepermi: any;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private config: NgSelectConfig,
    private modalService: BsModalService,
    private cdRef: ChangeDetectorRef
  ) {
    this.config.notFoundText = "Custom not found";
    this.config.appendTo = "body";
    this.config.bindValue = "value";

    let decid = this.route.snapshot.params["id"];
    decid = decid
      .toString()
      .replace(/Ar1t/g, "=")
      .replace(/FGH/g, "/")
      .replace(/THD/g, "+");
    this.id = this.UserService.decryptData(decid);
  }

  ngOnInit(): void {
    let UserId = localStorage.getItem("userId");
    this.userId = this.UserService.decryptData(UserId);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (
      (this.id == 0 &&
        this.permission.SalesTarget_Add != 1 &&
        this.userRId != 1) ||
      (this.id != 0 &&
        this.permission.SalesTarget_Edit != 1 &&
        this.userRId != 1)
    ) {
      if (this.permission.SalesTarget_View == 1) {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/salestarget/sales-target-list"]);
      } else {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/profile"]);
      }
      return;
    }

    this.registerForm = this.formBuilder.group({
      FinancialYear: [" ", Validators.required],
      ObjSalesTarget: this.formBuilder.array([]),
    });

    this.dropdownSettings = {
      singleSelection: true,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting = {
      singleSelection: true,
      text: "Financial Year",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: true,
      text: "Category",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting5 = {
      singleSelection: true,
      text: "Item Code",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    if (this.id != 0) {
      this.checkAddSales();
    }

    this.GetFinancialYear();
    this.SalesEnginner();
  }

  checkAddSales() {
    let data = {
      FinancialYear: this.id,
    };
    this.isRender = false;
    this.spinner.show();
    this.UserService.GetSalesTargetEditByYear(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.inquiryProduct = res["Data"];
          this.totalProductSize = res["TotalRecord"];
          if (this.totalProductSize == 0) {
            this.dollar = false;
          } else {
            this.dollar = true;
            let ObjSalesTarget = this.registerForm.get(
              "ObjSalesTarget"
            ) as FormArray;
            for (let i in this.inquiryProduct) {
              this.groups[i] = res["Data"][i]["SalesEngineerId"];
              this.rowvalue[i] = 1;
              this.CategoryShow = res["Data"][i]["SalesEngineer"];
              this.FinancialYear = res["FinancialYear"]["FY_Year"];
              this.selectedStatus[i] = res["Data"][i]["UserStatus"];
              if (res["FinancialYear"]["FY_Year"]) {
                this.selectedYear = [
                  {
                    id: res["FinancialYear"]["FY_Year"],
                    itemName: res["FinancialYear"]["FY_YearName"],
                  },
                ];
              }
              this.selectedYear.forEach((element) => {
                this.selectedFinancialName = element["itemName"];
                this.selectedFinancialId = element["id"];
              });

              ObjSalesTarget.push(
                this.formBuilder.group({
                  SalesTargetId: [this.inquiryProduct[i]["SalesTargetId"]],
                  SalesEngineerId: [this.groups[i], Validators.required],
                  SalesEngineerName: [this.inquiryProduct[i]["SalesEngineer"]],
                  BookingTarget: [
                    this.inquiryProduct[i].BookingTarget,
                    Validators.required,
                  ],
                  BillingTarget: [
                    this.inquiryProduct[i].BillingTarget,
                    Validators.required,
                  ],
                  EmployeeId: [this.inquiryProduct[i]["EmployeeId"]],
                  Status: ["1"],
                  check: false,
                })
              );
              this.getPrice(i);
            }
          }
          this.isRender = false;
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.toastrService.error(res["Msg"]);
        } else {
          this.toastrService.error(res["Msg"]);
          this.spinner.hide();
        }
        this.spinner.hide();
        this.submitted = false;
        this.multiClick = false;
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastrService.error(err.Msg || err.Message);
        }
      }
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  SalesEnginner() {
    let data = {
      Status: "1,2",
    };
    this.UserService.GetAllUserByStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.quotationArray = res;
        for (const quotationData of this.quotationArray["Data"]) {
          this.salesEng.push({
            id: quotationData["UserId"],
            itemName: `${quotationData["UserName"]} (${quotationData["EmailId"]}) ${quotationData["EmployeeId"]}`,
            status: quotationData["Status"],
          });
        }
        this.isRender = true;
        this.isFiltersRendered = true;
      } else {
        this.salesEng = [];
      }
    });
  }

  selecteddetail: string = "";
  selectedDetailId: number = 0;
  selectedStatus: any = {};
  onDetailSelect($event, j) {
    this.selecteddetail = "";
    this.cdRef.detectChanges();
    if ($event) {
      this.selectedDetailId = $event.id;
      this.selectedStatus[j] = $event.status;
    } else {
      this.categoryDeSelect(j);
    }
  }

  categoryDeSelect(j) {
    this.selectedDetailId = 0;
  }

  pasteNumbrother(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ BookingTarget: newText });
  }

  keyPressNumeric(event, i) {
    const pattern = /[^0-9]/g;
    if (!pattern.test(event.target.value)) {
      event.preventDefault();
      return false;
    } else {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      event.preventDefault();
      return false;
    }
  }

  parseNUmber(event, i) {
    if (event.target.value > 10000000.0) {
      this.toastrService.error("Value can not be greater than 10000000.00");
    }
  }

  parse(event, i) {
    if (event.target.value > 10000000.0) {
      this.toastrService.error("Value can not be greater than 10000000.00");
    }
  }

  keyPress(event, i) {
    const pattern = /[^0-9]/g;
    if (!pattern.test(event.target.value)) {
      event.preventDefault();
      return false;
    } else {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      event.preventDefault();
      return false;
    }
  }

  pasteNumbr(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ BillingTarget: newText });
  }

  getPrice(index: any) {
    let rows = this.registerForm.get("ObjSalesTarget") as FormArray;
    let billing = rows.value[index]?.BillingTarget;
    let booking = rows.value[index]?.BookingTarget;
    if (billing > 10000000.0) {
      billing = this.prevBill;
    }
    if (booking > 10000000.0) {
      booking = this.prevBook;
    }
    rows.controls[index]?.patchValue({
      BillingTarget: billing,
      BookingTarget: booking,
    });
    this.totalsum();
    this.prevBill = billing;
    this.prevBook = booking;
  }

  totalsum() {
    let rows = this.registerForm.get("ObjSalesTarget") as FormArray;
    this.TotalBilling = 0;
    this.TotalBooking = 0;
    for (const control of rows.controls) {
      if (control.value.Status === 1) {
        this.TotalBilling += Number(control.value.BillingTarget);
        this.TotalBooking += Number(control.value.BookingTarget);
      }
    }
    this.registerForm.patchValue({
      TotalBilling: this.TotalBilling.toFixed(2),
      TotalBooking: this.TotalBooking.toFixed(2),
    });
  }

  YearList: any = [];
  GetFinancialYear() {
    let data = {};
    this.UserService.GetFinancialYear(data).subscribe((res) => {
      if (res["result"] == "Success") {
        this.financialArray = res;
        for (const yearData of this.financialArray["FinancialYear"]) {
          this.YearList.push({
            id: yearData["FY_Year"],
            itemName: yearData["FY_YearName"],
          });
        }
      } else {
        this.financialArray = [];
      }
    });
  }
  selectedYear: any = [];
  selectedFinancialName: string = "";
  selectedFinancialId: string = "";
  onYearSelect(item: any) {
    this.selectedFinancialName = "";
    this.selectedFinancialId = "";
    this.selectedYear.forEach((element) => {
      this.selectedFinancialName = element["itemName"];
      this.selectedFinancialId = element["id"];
    });
  }

  onSubmit() {
    if (!this.checkProductList()) {
      this.toastrService.error(
        "Minimum 1 item row should be added to save the Sales Target"
      );
      return;
    }

    // Check for repeated SalesEngineerId
    const salesEngineerIds = new Set();
    const repeatedSalesEngineerIds = [];

    for (const target of this.registerForm.value.ObjSalesTarget) {
      const salesEngineerId = target.SalesEngineerId;
      const checkStatus = target.Status;

      if (
        salesEngineerIds.has(salesEngineerId) &&
        checkStatus != 3 &&
        salesEngineerId != "" &&
        salesEngineerId != undefined &&
        salesEngineerId != null
      ) {
        repeatedSalesEngineerIds.push(salesEngineerId);
      } else {
        salesEngineerIds.add(salesEngineerId);
      }
    }

    if (repeatedSalesEngineerIds.length > 0) {
      this.toastrService.error(
        `Sales Engineer are repeated. Please choose another`
      );
      return;
    }

    this.submitted = true;
    const data = {
      FinancialYear: this.selectedFinancialName,
      ObjSalesTarget: this.registerForm.value.ObjSalesTarget,
    };
    if (this.registerForm.valid) {
      this.multiClick = true;
      this.spinner.show();

      this.UserService.AddupdateSalesTarget(data).subscribe(
        (res) => {
          if (res["result"] == "Success") {
            this.errror = "";
            this.toastrService.success(res["Msg"]);
            this.router.navigate(["/salestarget/sales-target-list"]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            this.toastrService.error(res["Msg"]);
          } else {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required Fields");
      this.submitted = true;
    }
  }

  checkProductList() {
    let ObjSalesTarget = this.registerForm.get("ObjSalesTarget") as FormArray;
    for (const target of ObjSalesTarget.controls) {
      if (target.value.Status == 1) {
        return true;
      }
    }
    return false;
  }

  Addrow() {
    this.nonEdit = false;
    let ObjSalesTarget = this.registerForm.get("ObjSalesTarget") as FormArray;
    this.rowvalue[ObjSalesTarget.length] = 1;
    if (ObjSalesTarget.length <= 98) {
      ObjSalesTarget.push(
        this.formBuilder.group({
          SalesTargetId: 0,
          SalesEngineerId: ["", Validators.required],
          SalesEngineerName: [""],
          BookingTarget: ["", Validators.required],
          BillingTarget: ["", Validators.required],
          Status: ["1"],
          blankRow: [""],
          check: true,
        })
      );
    } else {
      this.toastrService.error("Maximum 99 rows are allowed at once");
    }
  }

  deleteOpenModal(template: TemplateRef<any>, index, data) {
    this.salesEngineer = data.SalesEngineerName;
    this.emailId = data.EmployeeId;
    this.rowId = index;
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  decline() {
    this.modalRef.hide();
  }

  deleteConfirm(j: any) {
    this.onDeleteRow(j);
    this.modalRef.hide();
  }

  onDeleteRow(rowIndex) {
    let ObjSalesTarget = this.registerForm.get("ObjSalesTarget") as FormArray;
    let fillValue = <FormArray>ObjSalesTarget.controls[rowIndex];
    if (fillValue.controls["blankRow"]?.value == "") {
      ObjSalesTarget.removeAt(rowIndex);
    } else {
      this.rowvalue[rowIndex] = 3;
    }
    this.cdRef.detectChanges();
    this.getPrice(rowIndex);
    this.totalsum();
  }

  view() {
    this.router.navigate(["/salestarget/sales-target-list"]);
  }
}
